angular.module('zc.zenclerkS')
  .controller('ZcsInvoiceShowController', ZcsInvoiceShowController);

ZcsInvoiceShowController.$inject = ['$stateParams', 'currencies', 'invoice', 'project'];
function ZcsInvoiceShowController($stateParams, currencies, invoice, project) {
  const vm = this;
  const currentMonth = moment($stateParams.term, 'YYYY-MM');

  vm.$onInit = () => {
    vm.invoiceMonth = $stateParams.term;
    vm.invoice = invoice;
    vm.project = project;
    vm.currentMonth = moment(currentMonth).endOf('month').format('YYYY/MM');

    vm.invoiceCurrency = currencies[vm.project.invoice_currency || 'jpy'];
    vm.isFixedPrice = !!project.fixed_invoice_amount;

    vm.isTerminated = false;
    if(project.terminated_at) {
      if(currentMonth.isSameOrAfter(moment(project.terminated_at))) {
        vm.isTerminated = true;
      }
    }

    const isMinimumChargeDiscounted = _.some(vm.invoice.adjustments, { adjustment_name: 'minimum_charge_discount' });
    if(isMinimumChargeDiscounted) {
      vm.invoice.adjustments = _.reject(vm.invoice.adjustments, adjustment =>
        _.includes(['minimum_charge', 'minimum_charge_discount'], adjustment.adjustment_name));
    }

    vm.hasInvoiceData = vm.invoice &&
      (
        vm.invoice.details.length > 0 ||
        vm.invoice.adjustments.length > 0 ||
        vm.invoice.invoice_price > 0
      );
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/invoices/show/invoice_show.controller.js